module.exports = __webpack_public_path__ + "img/main-logo.1040a999.png";